import { bool } from 'prop-types';
import React from 'react';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import { Button } from 'reactstrap';

export default function ExpandButton({ expanded, ...props }) {
  const Chevron = expanded ? GoChevronUp : GoChevronDown;

  return (
    <Button close {...props}>
      <Chevron />
    </Button>
  );
}

ExpandButton.propTypes = {
  expanded: bool.isRequired,
};
